import { oidcConfig } from '@shared/auth/constants';
import { objectUtils } from 'common/utils/object-utils';
import { CommonApi, CompanyResourcesApi } from '../../api/server';
import * as Payloads from './actions/payloads';
import { InvitationCompanyUsers } from './interfaces/invitation-company-users';
import { InvitationInfo, InvitationInfoC } from './interfaces/invitation-info';
import { PeopleV, Person } from './interfaces/person';

interface ValuePayload<T> {
  value: T;
}

function getCompanyUsers(): Promise<Person[]> {
  return CompanyResourcesApi.getV(`/users`, PeopleV);
}

function inviteUsersToCompany(data: InvitationCompanyUsers): Promise<Person[]> {
  return CompanyResourcesApi.postV(
    `/users`,
    { ...data, clientId: oidcConfig.client_id },
    PeopleV,
    'Error while inviting users to company',
  );
}

function getInvitationInfo(
  data: Payloads.InviteInfo,
): Promise<InvitationInfo> {
  const query = objectUtils.toQueryString(data);

  return CommonApi.getV(
    `/invitations/info?${query}`,
    InvitationInfoC);
}

function acceptInvitation(
  data: Payloads.InviteInfo,
): Promise<void> {
  return CommonApi.post('/invitations/accept', data, 'Error while accepting invitation');
}

function deleteCompanyPerson(
  userId: string,
): Promise<Person[]> {
  return CompanyResourcesApi.deleteV(
    `/users/${userId}`,
    PeopleV,
    'delete company person error',
  );
}

function removeUsersFromProject(
  projectId: number,
  emails: string[],
): Promise<void> {
  return CompanyResourcesApi.delete<void, ValuePayload<string[]>>(
    `/projects/${projectId}/users`,
    { value: emails },
    'Error while removing peopleFromProject');
}

function resendInvitation(userId: string): Promise<void> {
  return CompanyResourcesApi.post(
    `/users/${userId}/resend`,
    { clientId: oidcConfig.client_id },
    `Error during resend_invitation request for user = ${userId}`);
}

function updateUserRole(profileId: string, roleId: number): Promise<void> {
  return CompanyResourcesApi.put(
    `/users/${profileId}/role`,
    { roleId });
}

export const PeopleApi = {
  getCompanyUsers,
  inviteUsersToCompany,
  getInvitationInfo,
  acceptInvitation,
  deleteCompanyPerson,
  removeUsersFromProject,
  resendInvitation,
  updateUserRole,
};
